document.addEventListener("DOMContentLoaded", () => {
  const body = document.body;
  const pageType = window?.themeVariables?.settings?.pageType;

  const templateClassesToSkip = ["template-article", "template-collection"];
  const pageTypesToSkip = ["article", "collection"];

  const shouldSkipGlobalFade =
    pageTypesToSkip.includes(pageType) ||
    templateClassesToSkip.some((cls) => body.classList.contains(cls)) ||
    body.classList.contains("no-global-fade");

  if (shouldSkipGlobalFade) return;

  const sections = document.querySelectorAll(".shopify-section:not(.no-global-fade)");

  sections.forEach((section, index) => {
    // Apply to sections after the initial hero (index >= 2)
    if (index >= 2) {
      section.classList.add("fade-section");

      const imageItems = section.querySelectorAll("img:not(.product-item__primary-image):not(.product-item__image):not(.product-card__image):not(.product__media):not(.media)");
      imageItems.forEach((img) => img.classList.add("fade-image"));

      const innerItems = section.querySelectorAll(
        `.fade-item, .card, h1, h2, h3, h4, h5, h6, p, li, a, button, .prose, .text, .content, .inner, .wrapper`
      );

      innerItems.forEach((item) => {
        item.classList.add("fade-item");
        // No inline transitionDelay here means everything moves vertically together
      });
    }
  });

  const sectionObserver = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const items = entry.target.querySelectorAll(".fade-item");
          items.forEach((item) => item.classList.add("visible-item"));

          const images = entry.target.querySelectorAll("img.fade-image");
          images.forEach((img) => img.classList.add("visible-image"));

          sectionObserver.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.10 } // Trigger slightly earlier so the slow animation has time to show
  );

  sections.forEach((section) => sectionObserver.observe(section));
});